import { PhoneCall, CalendarCheck, PackageOpen, Truck, FileCheck2 } from "lucide-react";

const steps = [
  { icon: PhoneCall, n: "01", title: "Vous nous contactez", desc: "Un appel ou un formulaire. Réponse sous 24h." },
  { icon: CalendarCheck, n: "02", title: "Intervention planifiée", desc: "Devis transparent, date convenue ensemble." },
  { icon: PackageOpen, n: "03", title: "Récupération sur site", desc: "Manutention complète, descente, chargement." },
  { icon: Truck, n: "04", title: "Transport sécurisé", desc: "Vers notre centre agréé, traçabilité totale." },
  { icon: FileCheck2, n: "05", title: "Destruction + certificat", desc: "Broyage industriel, certificat officiel remis." },
];

export default function Process() {
  return (
    <section
      id="process"
      className="py-20 md:py-32 bg-white"
      data-testid="process-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-blue-600">
            Comment ça fonctionne ?
          </div>
          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-950" data-testid="process-title">
            5 étapes. Zéro effort.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-10 md:gap-y-12 relative">
          {/* Connector line - desktop */}
          <div className="hidden lg:block absolute top-6 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" aria-hidden />

          {steps.map(({ icon: Icon, n, title, desc }) => (
            <div
              key={n}
              className="relative"
              data-testid={`process-step-${n}`}
            >
              <div className="flex items-center gap-3">
                <Icon className="h-9 w-9 text-blue-600" strokeWidth={1.5} />
                <span className="font-display text-xs uppercase tracking-[0.2em] text-slate-400 font-bold">Étape {n}</span>
              </div>
              <h3 className="font-display mt-4 text-lg font-bold text-slate-950 tracking-tight">{title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
